import styled from '@emotion/styled';
import { Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }

  .ant-drawer-mask {
    background-color: transparent;
  }
`;
